import axios from 'axios';
import logComponent from '../logComponent';
import getConfig from './getConfig';

const Staging = (function() {
  function GetCorporations() {
    if (logComponent('Staging')) { console.debug('Staging GetPagedNotes'); }
    return axios.get('api/Staging/Corporation', getConfig());
  }

  function PutCorporation(corporation, rejectReason) {
    if (logComponent('Staging')) { console.debug('Staging PutCorporation'); }
    let params = {};
    if (rejectReason) params.rejectReason = rejectReason;

    return axios.put('api/Staging/Corporation', corporation, getConfig( params));
  }

  function DeleteCorporation(corporationId) {
    if (logComponent('Staging')) { console.debug('Staging DeleteCorporation'); }
    return axios.delete(`api/Staging/Corporation/${corporationId}`, getConfig());
  }

  function GetFacilities() {
    if (logComponent('Staging')) { console.debug('Staging GetFacilities'); }
    return axios.get('api/Staging/Facility', getConfig());
  }

  function PutFacility(facility, rejectReason) {
    if (logComponent('Staging')) { console.debug('Staging PutFacility'); }
    let params = {};
    if (rejectReason) params.rejectReason = rejectReason;

    return axios.put('api/Staging/Facility', facility, getConfig( params));
  }

  function DeleteFacility(facilityId) {
    if (logComponent('Staging')) { console.debug('Staging DeleteFacility'); }
    return axios.delete(`api/Staging/Facility/${facilityId}`, getConfig());
  }

  return {
    Corporation: {
      get: GetCorporations,
      put: PutCorporation,
      delete: DeleteCorporation
    },
    Facility: {
      get: GetFacilities,
      put: PutFacility,
      delete: DeleteFacility
    }
  }
})();

export default Staging;